<template>
  <div class="add-step">
    <div class="bg-black add-accont-header">
      <div class="add-brd">
        <div class="h-back" @click="goBackHandler">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M15 19l-7-7 7-7"
            />
          </svg>
        </div>
        <h2>شماره کارت</h2>
        <p>مرحله بعد: تنظیم جزئیات حساب</p>
      </div>
      <div>
        <svg class="header-progresbar">
          <circle class="meter" cx="57" cy="57" r="42" />
          <circle class="meter-1" cx="57" cy="57" r="42" />
          <text class="SVG-text" x="37" y="47">مرحله</text>
          <text x="65" y="74" class="SVG-text">2</text>
          <text x="50" y="74" class="SVG-text">از</text>
          <text x="37" y="74" class="SVG-text">4</text>
        </svg>
      </div>
    </div>
    <div class="add-card">
      <p v-if="bank != 'ayandeh' && bank != 'keshavarzi'">
        با کلیک بر کارت زیرمی‌توانید
      </p>
      <p v-if="bank != 'ayandeh' && bank != 'keshavarzi'">
        شماره کارت خود را وارد کنید
      </p>
      <div class="cardName">
        <input v-model="model.name" class="inputName" placeholder="نام حساب" />
      </div>
      <div class="container preload" @click="input_focus">
        <div
          class="creditcard"
          v-if="bank != 'ayandeh' && bank != 'keshavarzi'"
        >
          <div class="front">
            <svg
              version="1.1"
              id="cardfront"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 750 471"
              style="enable-background: new 0 0 750 471"
              xml:space="preserve"
            >
              <g id="Front">
                <g id="CardBackground">
                  <g id="Page-1_1_">
                    <g id="amex_1_">
                      <path
                        id="Rectangle-1_1_"
                        class="lightcolor grey"
                        d="M40,0h670c22.1,0,40,17.9,40,40v391c0,22.1-17.9,40-40,40H40c-22.1,0-40-17.9-40-40V40
                            C0,17.9,17.9,0,40,0z"
                      />
                    </g>
                  </g>
                  <path
                    class="darkcolor greydark"
                    d="M750,431V193.2c-217.6-57.5-556.4-13.5-750,24.9V431c0,22.1,17.9,40,40,40h670C732.1,471,750,453.1,750,431z"
                  />
                </g>
                <!-- <text   transform="matrix(1 0 0 1 60.106 295.0121)" id="svgnumber"  class="st2 st3 st4">XXXX XXXX XXXX XXXX</text> -->
                <foreignObject
                  transform="matrix(1 0 0 1 60.106 295.0121)"
                  width="80%"
                  height="150"
                >
                  <input
                    v-model="cardNumber"
                    class="inputCardNumberClass"
                    v-maska="'#### #### #### ####'"
                    ref="cardNumberInput"
                    @keyup="idBank"
                  />
                </foreignObject>
              </g>
            </svg>
          </div>
        </div>
      </div>
      <p class="errcard" v-if="err">شماره کارت متعلق به بانک شما نیست.</p>
      <button
        class="m-btn add-confer-btn"
        v-if="allowCreat"
        @click="addCardHandeler"
      >
        تایید
      </button>
    </div>
  </div>
</template>

<script>
import { maska } from "maska";
export default {
  directives: { maska },
  mounted() {
    this.getBanks();
    this.bank = this.$store.state.accounts.bank.toLowerCase();
    if (this.bank == "ayandeh" || this.bank == "keshavarzi")
      this.allowCreat = true;
  },
  data() {
    return {
      banks: [],
      bank: null,
      err: false,
      allowCreat: false,
      cardNumber: "0000 0000 0000 0000",
      model: {
        card_number: null,
        name: null,
        bank: {
          name: null,
          bank_id: null,
        },
      },
    };
  },
  methods: {
    getBanks() {
      this.$store.dispatch("accounts/getBanksList").then((rsp) => {
        this.banks = rsp;
      });
    },
    idBank() {
      var bankCode = this.cardNumber.replace(/\s/g, "").substring(0, 6);
      if (this.cardNumber.length == 7) {
        for (var i = 0; i < this.banks.length; i++) {
          if (bankCode == this.banks[i].card_digits) {
            if (this.bank == this.banks[i].name.toLowerCase()) {
              this.model.bank.name = this.banks[i].name;
              this.model.bank.bank_id = this.banks[i].bank_id;
              this.err = false;
              this.allowCreat = true;
            } else {
              this.err = true;
              this.allowCreat = false;
            }
          }
        }
      }
    },
    input_focus() {
      this.$refs.cardNumberInput.focus();
      if (this.cardNumber == "0000 0000 0000 0000") {
        this.cardNumber = null;
      }
    },
    addCardHandeler() {
      if (this.cardNumber != null && this.cardNumber != "0000 0000 0000 0000") {
        this.model.card_number = this.cardNumber.replace(/\s/g, "");
      } else if (this.cardNumber == "0000 0000 0000 0000") {
        for (var j = 0; j < this.banks.length; j++) {
          if (this.bank == this.banks[j].name.toLowerCase()) {
            this.model.bank.name = this.banks[j].name;
            this.model.bank.bank_id = this.banks[j].bank_id;
          }
        }
      }
      this.model.is_default = false;
      this.$store.commit("accounts/setModel", this.model);
      this.$emit("next");
      // this.$store.dispatch("accounts/addAccount", this.model).then(rsp => {
      //   window.location.href = rsp.url
      // });
    },
    goBackHandler() {
      this.$router.back();
    },
  },
};
</script>

<style scoped>
.err {
  margin-top: 57px;
  color: red;
}
.inputCardNumberClass {
  background: none;
  border: none;
  font-size: 58px;
  padding: 0;
}
.inputCardNumberClass:focus {
  background: none;
  border: none;
  font-size: 58px;
  outline: none;
  padding: 0;
}
.inputName {
  width: 90%;
  direction: rtl;
}
.ccicon {
  height: 38px;
  position: absolute;
  right: 6px;
  top: calc(50% - 17px);
  width: 60px;
}

/* CREDIT CARD IMAGE STYLING */
.preload * {
  -webkit-transition: none !important;
  -moz-transition: none !important;
  -ms-transition: none !important;
  -o-transition: none !important;
}

.container {
  width: 100%;
  max-width: 400px;
  max-height: 251px;
  height: 54vw;
  margin-top: 20px;
}

#ccsingle {
  position: absolute;
  right: 15px;
  top: 20px;
}

#ccsingle svg {
  width: 100px;
  max-height: 60px;
}

.creditcard svg#cardfront,
.creditcard svg#cardback {
  width: 100%;
  -webkit-box-shadow: 1px 5px 6px 0px black;
  box-shadow: 1px 5px 6px 0px black;
  border-radius: 22px;
}

#generatecard {
  cursor: pointer;
  float: right;
  font-size: 12px;
  color: #fff;
  padding: 2px 4px;
  background-color: #909090;
  border-radius: 4px;
  cursor: pointer;
  float: right;
}

/* CHANGEABLE CARD ELEMENTS */
.creditcard .lightcolor,
.creditcard .darkcolor {
  -webkit-transition: fill 0.5s;
  transition: fill 0.5s;
}

.creditcard .lightblue {
  fill: #03a9f4;
}

.creditcard .lightbluedark {
  fill: #0288d1;
}

.creditcard .red {
  fill: #ef5350;
}

.creditcard .reddark {
  fill: #d32f2f;
}

.creditcard .purple {
  fill: #ab47bc;
}

.creditcard .purpledark {
  fill: #7b1fa2;
}

.creditcard .cyan {
  fill: #26c6da;
}

.creditcard .cyandark {
  fill: #0097a7;
}

.creditcard .grey {
  fill: #000;
}

.creditcard .greydark {
  fill: #616161;
}

/* FRONT OF CARD */
#svgname {
  text-transform: uppercase;
}

#cardfront .st2 {
  fill: #ffffff;
}

#cardfront .st3 {
  font-family: "Source Code Pro", monospace;
  font-weight: 600;
}

#cardfront .st4 {
  font-size: 54.7817px;
}

#cardfront .st5 {
  font-family: "Source Code Pro", monospace;
  font-weight: 400;
}

#cardfront .st6 {
  font-size: 33.1112px;
}

#cardfront .st7 {
  opacity: 0.6;
  fill: #ffffff;
}

#cardfront .st8 {
  font-size: 24px;
}

#cardfront .st9 {
  font-size: 36.5498px;
}

#cardfront .st10 {
  font-family: "Source Code Pro", monospace;
  font-weight: 300;
}

#cardfront .st11 {
  font-size: 16.1716px;
}

#cardfront .st12 {
  fill: #4c4c4c;
}
</style>
